import * as React from 'react';
import { upsertUserFavourite, deleteUserFavourite, fetchUserFavourites } from './../actions/userFavouriteThunkActions';
import { UserFavouriteTileButton as UserFavouriteTileButtonComponent } from '@shared/components/userFavouriteTileButton';
const { connect } = require('react-redux');
export const mapStateToProps = (state, ownProps)=>{
    return {
        userInfo: state.users,
        userFavourite: state.userFavourite,
        entityId: ownProps.entityId,
        entityType: ownProps.entityType,
        item: ownProps.item
    };
};
export const mapDispatchToProps = (dispatch, ownProps)=>{
    return {
        fetchUserFavouriteData: ()=>dispatch(fetchUserFavourites()),
        savefavourite: (entityId, payload, item)=>dispatch(upsertUserFavourite(payload, item, entityId)),
        deleteFavourite: (entityGuid, applicationType)=>dispatch(deleteUserFavourite(entityGuid, applicationType))
    };
};
const UserFavouriteTileButton = connect(mapStateToProps, mapDispatchToProps)(UserFavouriteTileButtonComponent);
export default UserFavouriteTileButton;
